import { SetStateAction, Dispatch, ReactNode } from "react";
import { Box, Stack, useTheme } from "@mui/material";

import { PaginationTables } from "../PaginationTables/PaginationTables";
import { SelectQtdTables } from "../SelectQtdTables/SelectQtdTables";

import { InpuSearchPersonalized } from "./InpuSearchPersonalized/InpuSearchPersonalized";

type IPaginationAndSelect = {
  setNameSearch?: Dispatch<SetStateAction<string>>;
  qtd_registros: number;
  Filter?: ReactNode;
};

export const JoinPaginationAndSelect = ({
  setNameSearch,
  qtd_registros,
  Filter,
}: IPaginationAndSelect) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        margin: "16px  auto 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.up("md")]: {
          justifyContent: "space-between",
          flexDirection: "row",
        },
      }}
    >
      <Stack
        alignItems="center"
        sx={{
          flexDirection: "row",
          [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
          },
        }}
      >
        <PaginationTables qtdRegister={qtd_registros} />

        {Filter && Filter}
      </Stack>

      {setNameSearch && (
        <InpuSearchPersonalized setNameSearch={setNameSearch} />
      )}
      <SelectQtdTables qtd_Itens={qtd_registros} />
    </Box>
  );
};
